import { render } from "./AppEmail.vue?vue&type=template&id=7af130ad"
import script from "./AppEmail.vue?vue&type=script&lang=ts"
export * from "./AppEmail.vue?vue&type=script&lang=ts"
script.render = render

export default script